import React from 'react'

const NftAttrItem = (props) => {
  const { data } = props
  
  return data.value && (
    <div className='rounded-xl border border-gray-200 font-mukto-normal font-bold bg-gray-100 flex flex-col items-center justify-center uppercase px-2 h-24 py-2'>
      <p className='text-blue-normal text-center text-sm line-height-medium'>{data.trait_type}</p>
      <p className={`text-center ${data.value?.length < 26 ? "text-lg" : data.value?.length > 29 ? "text-sm" : ""} leading-5 max-w-40`}>{data.value}</p>
      <p className='text-blue-normal text-center text-lg'>{(data.rarity / 5000 * 100).toFixed(2)} %</p>
    </div>
  )
}

const NftModal = (props) => {
  const { open, setOpen, nftData } = props

  return (
    <div className={`fixed ${!open && "hidden"} z-50 inset-0 overflow-y-auto h-full w-full px-4 modal bg-black bg-opacity-40 flex items-center justify-center`} onClick={() => setOpen(false)}>
      <div className="relative mx-auto rounded-2xl shadow-xl bg-white max-w-120 flex flex-col lg:flex-row gap-6 py-6 lg:p-6 nft-modal" style={{ zIndex: 200 }} onClick={(e) => e.stopPropagation()}>
        <div className='flex flex-col items-center'>
          <p className='text-center font-montserrat-bold uppercase text-3xl'>
            {nftData?.data.name}
          </p>
          <a href={nftData?.img} target="_blank" rel="noreferrer" className="underline text-blue-normal">
            View Original Size
          </a>
          <img src={nftData?.thumb} className='rounded-3xl h-63 mt-2 bg-black' alt="nft" />
        </div>
        <div className='nft-attr pr-2 pl-6 lg:pr-0 lg:pl-0 flex flex-col justify-center'>
          <div>
            <p className='font-bold uppercase text-2xl text-center font-montserrat-bold mt-2'>traits:</p>
          </div>
          <div className='overflow-y-auto grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-2 xl:grid-cols-3 gap-4 h-80 mt-4 pr-6'>
            {nftData?.data.attributes.map((data, idx) => (
              <NftAttrItem data={data} key={idx} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default NftModal